module.exports = __webpack_public_path__ + "static/media/menu.e9d827a4.svg";